import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useConfirmPasswordReset() {
  return useMutation({
    mutationFn: (data: { token: string; password: string }) =>
      http.post("/reset-password/confirm", data).then((res) => res.data),
  });
}
